import { gql } from '@apollo/client'

export default gql(`
    mutation addAssetCreditLinks($input: [AssetCreditLinkInput] $project: String $module: String) {
        addAssetCreditLinks(
            input: $input
            project: $project
            module: $module
        ){
            id
        }
    }`
)
